import React from 'react';
import { Breadcrumb } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

// group   : sidebar group the page belongs to (no page of its own, so not a link)
// label   : the list page
// path    : the list page url
// detail  : title of the "view" page (e.g. /clients/12, /contract/nda/5)
const sections = {
  clients: {
    group: 'Manage Clients',
    label: 'Clients',
    path: '/clients',
    detail: 'Client Details',
  },
  nda: {
    group: 'Manage Clients',
    label: 'NDA',
    path: '/nda',
    detail: 'NDA Details',
  },
  msa: {
    group: 'Manage Clients',
    label: 'MSA',
    path: '/msa',
    detail: 'MSA Details',
  },
  projects: {
    group: 'Engagements',
    label: 'Engagement/Projects',
    path: '/projects',
    detail: 'Project Details',
  },
  resources: {
    group: 'Engagements',
    label: 'Resource utilisation',
    path: '/resources',
  },
  sow: {
    group: 'Engagements',
    label: 'SOW',
    path: '/sow',
    detail: 'SOW Details',
  },
  po: {
    group: 'Engagements',
    label: 'PO',
    path: '/po',
    detail: 'PO Details',
  },
  cr: {
    group: 'Engagements',
    label: 'CR',
    path: '/cr',
    detail: 'CR Details',
  },
  pendingApprovals: {
    group: null,
    label: 'Pending Approvals',
    path: '/pendingApprovals',
    detail: null,
  },
};

const AppBreadcrumb = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const parts = pathname.split('/').filter(Boolean);
  // Dashboard ("/") has no breadcrumb
  if (parts.length === 0) return null;

  // /contract/:contractType/:id  ->  section of that contract type (view page)
  // /clients/:id, /projects/:id  ->  view page of that section
  let key = parts[0];
  let isDetail = parts.length > 1;
  if (key === 'contract') {
    key = parts[1];
    isDetail = true;
  }

  const section = sections[key];
  if (!section) return null;

  const showDetail = isDetail && section.detail;

  const goTo = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };

  const items = [
    {
      title: (
        <a href="/" onClick={goTo('/')}>
          <HomeOutlined />
        </a>
      ),
    },
    ...(section.group ? [{ title: section.group }] : []),
    showDetail
      ? {
          title: (
            <a href={section.path} onClick={goTo(section.path)}>
              {section.label}
            </a>
          ),
        }
      : { title: section.label },
  ];

  if (showDetail) {
    items.push({ title: section.detail });
  }

  return <Breadcrumb items={items} style={{ marginBottom: 0 }} />;
};

export default AppBreadcrumb;
